import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Config from "../../Config";
import { LinearProgress } from "@mui/material";
import SuccessImg from '../../assets/img/img/success.png';
import CautionImg from '../../assets/img/img/caution.png';
import FailedImg from '../../assets/img/img/failed.png';
import { useNavigate } from "react-router-dom";


function PaymentStatus() {
  const [status, setStatus] = useState();
  const [title, setTitle] = useState();
  const [message, setMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [img, setImg] = useState();
  const navigate = useNavigate();


  async function fetchData() {
    let invoiceId = localStorage.getItem("invoiceid");
    // const invoiceId = "INV00002428";
    const url = Config.API_URL + "get_status?invoiceID=" + invoiceId;

    let response = await axios.post(url);
    setStatus(response.status);

    if (status) {
      setIsLoading(true);
      details.map((detail) => {
        if ('11' == detail.status) {
          setTitle(detail.title);
          setMessage(detail.message);
          setImg(detail.img);
        }
      });
    }
  }

  useEffect(() => {

document.title = "Payment Status";
    let invoiceId = localStorage.getItem("invoiceid");
    // const invoiceId = "INV00002428";
    const url = Config.API_URL + "get_status?invoiceID=" + invoiceId;

    axios
      .post(url)
      .then(function (response) {
        setStatus(response.data.status);

        details.map((detail) => {
          if (response.data.status == detail.status) {
            setTitle(detail.title);
            setMessage(detail.message);
            setImg(detail.img)
          }
        });
        setIsLoading(true);
        localStorage.clear();
      })
      .catch(function (error) {
        if (invoiceId === null){
          Swal.fire({
            title: "Error!",
            html: "No payment has been made!",
            icon: "error",
            confirmButtonText: "Okay",
          });
          navigate("/");
        } else {
        Swal.fire({
          title: "Error!",
          html: error.response.data[0].msg,
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
      });
    
  }, []);

  const details = [
    {
      status: "00",
      title: "Thank you for your payment!",
      message:
        "Your online transaction has been successfully processed and will be reflected on your Invoice History.",
        img: SuccessImg
    },
    {
      status: "11",
      title: "Payment Unsuccessful",
      message:
        "Your online transaction unfortunately cannot be processed. Please try again or try a different payment method ensuring all the correct details have been entered.",
        img: FailedImg
    },
    {
      status: "22",
      title: "Payment Pending",
      message:
        "We have received your payment and it is currently being processed. Payment status will be updated once it is processed.",
        img: CautionImg
    },
  ];

  return (
    <div className="h-screen flex items-center content-center justify-center align-middle">
      <div className="card sm:w-4/5 lg:w-2/5 bg-base-100 shadow-xl">
        <div className="card-body">
					{!isLoading && (
						  <div className="mt-3 mb-3">
						  <p>
							Loading... <span>Please Wait..</span>
						  </p>
						  <LinearProgress color="error" />
						</div>
					)}
          {isLoading && (
            <div>
              <img src={img} alt="" className="img-fluid w-25 mx-auto d-block py-4 " style={{height: '200px'}}/>
              <h2 className="sm:text-xl lg:text-3xl text-center mb-3 sm:font-extrabold lg:font-semibold font-black">{title}</h2>
              <p className="sm:text-md lg:text-lg mb-9 sm:font-semibold lg:font-normal font-semibold ">{message}</p>

              <div className="mr-1">Operating Hours: 9am-6pm (Mon to Fri) </div>
              <div className="mr-1">Phone: 0327750100 </div>
              <div className="mr-1">
                Email:
                <a href="mailto:billing@viewqwest.com">
                  {" "}
                  billing@viewqwest.com
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentStatus;
